// extracted by mini-css-extract-plugin
export default {"filtration_wrapper":"Testing_filtration_wrapper__P5omf","filtration_title":"Testing_filtration_title__A9h4k"};